<template>
    <div class="floatingsv2" v-if="floatings && floatings.length > 0">
        <div class="title">
            <div class="left">
                <span
                    v-html="$translate('USER_LIKE_TITLE').replace(/%s/, $nameOrNick($store.getters.chat.user))"
                ></span>
                <span class="count">{{ (floatings || []).length }}</span>
            </div>
            <div class="delete-all" @click="deleteAll">전체삭제</div>
        </div>
        <div class="order" v-if="orderTestAgents.indexOf(agent.id) > -1">
            <div>정렬하기</div>
            <div class="order-title" @click="() => (order = !order)" :class="{ selected: selectedOrder }">
                {{ selectedOrder ? selectedOrder.label : '선택하기' }}
            </div>
            <div class="order-items" v-show="order">
                <div class="order-item" v-for="(o, idx) in orderItems" :key="idx" @click="onClickOrder(o)">
                    {{ o.label }}
                </div>
            </div>
        </div>
        <transition-group
            name="list"
            class="floatingv2-items flex-row"
            :class="{ 'toggle-on': toggle, 'toggle-off': !toggle }"
        >
            <FloatingV2
                class="flex-wrap list-item"
                :floating="floating"
                :chatId="floating.chat_id"
                :key="floating.id"
                v-for="floating in floatings"
            />
        </transition-group>
        <div class="toggle" @click.stop="onClickToggle">
            <i class="material-icons">{{ toggle ? 'expand_less' : 'expand_more' }}</i>
        </div>
    </div>
</template>

<script>
import FloatingV2 from './FloatingV2'
import chatFloatingService from '@/services/chat-floating'

export default {
    name: 'FloatingsV2',
    components: { FloatingV2 },
    computed: {
        floatings() {
            const chat = this.$store.getters.chat
            if (!chat) return

            return chat.$$floatingsInterest
        },
        floatingIds() {
            return this.floatings.map(f => f.id)
        },
        chat() {
            return this.$store.getters.chat
        },
        agent() {
            return this.$store.getters.agent || {}
        },
        orderTestAgents() {
            return [17979, 16793, 18004, 18028, 18025, 18030, 18024, 18019, 17991, 18009]
        },
        orderItems() {
            return [
                {
                    label: '기본값',
                    key: 'default',
                },
                {
                    label: '나이 오름차순',
                    key: 'age',
                    orderBy: 'asc',
                },
                {
                    label: '나이 내림차순',
                    key: 'age',
                    orderBy: 'desc',
                },
                {
                    label: '거리 오름차순',
                    key: 'distance',
                    orderBy: 'asc',
                },
                {
                    label: '거리 내림차순',
                    key: 'distance',
                    orderBy: 'desc',
                },
                {
                    label: '피호감율 오름차순',
                    key: 'like',
                    orderBy: 'asc',
                },
                {
                    label: '피호감율 내림차순',
                    key: 'like',
                    orderBy: 'desc',
                },
            ]
        },
    },
    data: () => ({
        toggle: false,
        order: false,
        selectedOrder: null,
    }),
    watch: {
        chat(oldVal, newVal) {
            this.selectedOrder = null
            this.order = false
        },
    },
    mounted() {
        const isToggle = sessionStorage.getItem('toggle')
        console.log(isToggle)
        this.toggle = JSON.parse(isToggle)
    },
    methods: {
        onClickOrder(o) {
            // if ((this.selectedOrder || {}).key === o.key) {
            //     this.order = !this.order
            //     return
            // }
            if (o.key === 'default') {
                this.order = !this.order
                this.selectedOrder = null
                this.$store.dispatch('loadChatFloatings', this.chat.id)
                return
            }
            this.order = !this.order
            this.selectedOrder = o
            this.floatings.sort((a, b) => {
                if (o.key === 'distance')
                    return o.orderBy === 'asc'
                        ? a.user.$$distance - b.user.$$distance
                        : b.user.$$distance - a.user.$$distance
                if (o.key === 'age')
                    return o.orderBy === 'asc'
                        ? this.$options.filters.asAge(a.user.profile.birthday) -
                              this.$options.filters.asAge(b.user.profile.birthday)
                        : this.$options.filters.asAge(b.user.profile.birthday) -
                              this.$options.filters.asAge(a.user.profile.birthday)
                if (o.key === 'like') {
                    return o.orderBy === 'asc'
                        ? a.likability_rate - b.likability_rate
                        : b.likability_rate - a.likability_rate
                }
            })
            // this.$set(this.chat, $$floatingsInterest, orderedInterest)
        },
        onClickToggle() {
            this.toggle = !this.toggle
            sessionStorage.setItem('toggle', this.toggle)
        },
        async deleteAll() {
            const idx = await this.$modal.basic({
                body: '호감박스를 제거하시겠습니까?',
                buttons: [
                    {
                        label: '취소',
                        class: 'btn-default',
                    },
                    {
                        label: '확인',
                        class: 'btn-primary',
                    },
                ],
            })
            if (idx) {
                try {
                    const { msg } = await chatFloatingService.deleteAll(this.chat.id, this.floatingIds)
                    if (msg) {
                        this.$loading(true)
                        const floatingsRemoved = { ...this.chat, $$floatingsInterest: [] }
                        this.$store.commit('setChat', floatingsRemoved)
                        this.$toast.success('호감박스가 제거되었습니다.')
                    }
                } catch (e) {
                    this.$toast.error('호감박스 제거에 실패했어요')
                } finally {
                    this.$loading(false)
                }
            }
        },
    },
}
</script>
